import { z } from 'zod';
/** Google's hard limits on a keyword or negative keyword: 80 characters AND
 *  10 words. Both apply; a term can pass one and fail the other.
 *
 *  THIS COST FOUR GOOD EXCLUSIONS IN PRODUCTION. On 2026-10-15 mag judged five
 *  search terms on magig and the mutate came back
 *  "negatives_failed: Request contains an invalid argument." The culprit was
 *
 *    "why might you use the search network campaigns with display opt in campaign type"
 *
 *  — exactly 80 characters (passing that limit on the nose) and 14 words. The
 *  Google mutate is ATOMIC, so the other four — 'my business', 'google promo',
 *  'best business apps for android', 'реклама google youtube', all well inside
 *  both limits — were discarded with it. Mag judged correctly, told the founder
 *  so in an email, and excluded nothing.
 *
 *  The error names NEITHER limit, which is why the char check alone looked
 *  sufficient for as long as it did. */
export const GOOGLE_KEYWORD_MAX_CHARS = 80;
export const GOOGLE_KEYWORD_MAX_WORDS = 10;
/** Can this term be used as a Google keyword or negative keyword at all?
 *
 *  THE ONE DEFINITION of "Google will accept this". It lives in schemas rather
 *  than in apps/api because the eight payload shapes that become a keyword
 *  write are declared here, and the rule belongs where the shapes are. Two
 *  spellings of it would agree today and drift the first time either limit
 *  moved, in the direction nobody tests: a selector offering a term the
 *  planner then drops, or worse, a planner sending one Google refuses.
 *
 *  Word counting is whitespace-separated, which is what Google does for the
 *  space-delimited languages these campaigns run in. A script without spaces
 *  would count as one word here and Google would agree, so the two stay
 *  consistent even where the notion of "word" does not transfer. */
export function isUsableAsGoogleKeyword(text) {
    const trimmed = text.trim();
    if (trimmed.length === 0)
        return false;
    if (trimmed.length > GOOGLE_KEYWORD_MAX_CHARS)
        return false;
    return trimmed.split(/\s+/).length <= GOOGLE_KEYWORD_MAX_WORDS;
}
/** Keyword text on any payload that BECOMES a Google write.
 *
 *  Refused here rather than at the mutate, because both keyword mutates are
 *  ATOMIC and one of them is deliberately not best-effort: a negative that
 *  silently fails to apply means the campaign serves the exact queries the
 *  founder said to exclude, so `launchCampaign` would rather report failure
 *  than succeed on a campaign that excludes nothing. One 11-word term from an
 *  LLM-authored proposal therefore takes the whole step down — after the
 *  campaign is live and spending.
 *
 *  NOT for READ shapes. `keywordSnapshotSchema` deliberately keeps a bare
 *  character bound: an imported account can hold a keyword we would never
 *  write, and a read that refuses to parse it blinds every health surface on
 *  that campaign. The asymmetry is the point — we are strict about what we
 *  send and permissive about what we are told. */
export const googleKeywordTextSchema = z
    .string()
    .min(1)
    .max(GOOGLE_KEYWORD_MAX_CHARS)
    .refine(isUsableAsGoogleKeyword, {
    // Names the word count, because Google's own "invalid argument" names
    // neither limit and the char limit is the one everybody checks first.
    message: `keyword must be at most ${GOOGLE_KEYWORD_MAX_CHARS} characters and ${GOOGLE_KEYWORD_MAX_WORDS} words`,
});
//# sourceMappingURL=google-keyword.js.map